"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMessage = exports.getKeyPair = void 0;
const core = __importStar(require("@keepkey/hdwallet-core"));
const ethers_1 = require("ethers");
const Isolation = __importStar(require("./crypto/isolation"));
const networks_1 = require("./networks");
function getKeyPair(node, addressNList, coin, scriptType) {
    return __awaiter(this, void 0, void 0, function* () {
        const network = (0, networks_1.getNetwork)(coin, scriptType);
        const wallet = yield Isolation.Adapters.BIP32.create(node, network);
        const path = core.addressNListToBIP32(addressNList);
        return yield wallet.derivePath(path);
    });
}
exports.getKeyPair = getKeyPair;
function buildMessage(message) {
    const messageBytes = typeof message === "string" && !ethers_1.ethers.utils.isHexString(message)
        ? ethers_1.ethers.utils.toUtf8Bytes(message)
        : ethers_1.ethers.utils.arrayify(message);
    return ethers_1.ethers.utils.concat([
        ethers_1.ethers.utils.toUtf8Bytes("\x19Ethereum Signed Message:\n"),
        ethers_1.ethers.utils.toUtf8Bytes(String(messageBytes.length)),
        messageBytes,
    ]);
}
exports.buildMessage = buildMessage;
//# sourceMappingURL=util.js.map